// src/services/pdf/data/mapSummaryToPDFData.ts
// Maps GPSummaryData + supplementary data into the full PDFRenderData structure.

import type { GPSummaryData } from "../../../types/gpSummary";
import type { PDFRenderData, PDFSectionToggles, PWQuestionnaireResponse } from "../types";
import { computeFlags } from "./computeFlags";
import { computeGPActions } from "./computeGPActions";

export interface MapSummaryInput {
  summaryData: GPSummaryData;
  pwResponses: PWQuestionnaireResponse[];
  notes: string;
  toggles: PDFSectionToggles;
}

/**
 * Assembles all data needed for PDF rendering into a single structure.
 * Computes derived data (flags, GP actions) from the raw summary.
 */
export function mapSummaryToPDFData(input: MapSummaryInput): PDFRenderData {
  const { summaryData, pwResponses, notes, toggles } = input;

  const flags = computeFlags(summaryData);
  const gpActions = computeGPActions(summaryData, pwResponses);

  return {
    summaryData,
    flags,
    gpActions,
    pwResponses,
    notes,
    toggles,
    generatedAt: new Date(),
  };
}
